import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { contextProvider } from "../../../context/ContextProvider";
import Alerts from "../../components/Alerts/Alerts";
import Login from "../../page/login/Login";
import RestApi from "../../../helpers/RestApi";
import clienteAntesala from "../../../config/Config";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";

const LoginController = () => {
  const navigation = useNavigate();
  const context = useContext(contextProvider);
  const { FORMs, VALIDATIONs, URLs } = context;

  const { URL_LOGIN, URL_ME } = URLs;
  const { FORM_LOGIN } = FORMs;
  const { VALIDATION_FORM_LOGIN } = VALIDATIONs;

  const [referrer, setReferrer] = useState("");
  const [form, setForm] = useState(JSON.parse(JSON.stringify(FORM_LOGIN)));
  const [validation, setValidation] = useState(
    JSON.parse(JSON.stringify(VALIDATION_FORM_LOGIN))
  );

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [recaptcha, setRecaptcha] = useState(null);
  const [loginError, setLoginError] = useState("");

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "show":
        {
          e.preventDefault();
          setShowPassword(!showPassword);
        }
        break;
      case "login":
        {
          e.preventDefault();
          let error = false;
          let validations = validation;

          if (form.email[0].trim() == "") {
            error = true;
            validations.email.msg = "Campo obligatorio";
            validations.email.validate = true;
          }

          if (form.password[0].trim() == "") {
            error = true;
            validations.password.msg = "Campo obligatorio";
            validations.password.validate = true;
          }

          setValidation({
            ...validation,
          });

          if (error) {
            setLoginError("");
            return "";
          }

          /* Iniciar sesion */
          let dataForm = new FormData();
          dataForm.append("email", form.email[0]);
          dataForm.append("password", form.password[0]);
          dataForm.append("g-recaptcha-response", recaptcha);

          const _response = await RestPrivateAntesala({
            method: "post",
            url: "/auth/login",
            formData: dataForm,
            setLoading: () => { },
          });

          if (
            (_response.status == 201 ||
              _response.status == 200)
          ) {
            localStorage.setItem("token_api", _response.data.tokens.token);
            localStorage.setItem("token", _response.data.tokens.external_data);

            const me = await clienteAntesala.get("/auth/me", {});

            Alerts({
              msg: "Alert",
              title: _response.data.msg,
              code: "201",
              type: "success",
            });

            if (me.status == 201 || me.status == 200) {
              let rol = me.data.roles[0];
              if (rol.id == 2) {
                if (referrer.includes("entrada")) {
                  return (window.location.href = referrer);
                }
                return (window.location.href = '/');
              }

              if (rol.id == 1 || rol.id == 3 || rol.id == 4) {
                if (referrer.includes("entrada")) {
                  return (window.location.href = referrer);
                }
                return (window.location.href = "/dashboard/eventos");
              }
            }
          } else {
            if (typeof _response.data.msg === "string") {
              setLoginError(_response.data.msg);
            } else {
              const firstError = Object.keys(_response.data.msg)[0];
              setLoginError(_response.data.msg[firstError][0]);
            }
          }
        }
        break;
    }
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "password":
      case "email":
        {
          setValidation(JSON.parse(JSON.stringify(VALIDATION_FORM_LOGIN)));
          setLoginError("");

          let setValue = form;
          setValue[e.target.name][0] = e.target.value;

          return setForm({
            ...form,
            [e.target.name]: setValue[e.target.name],
          });
        }
        break;
    }
  };

  useEffect(() => {
    setReferrer(document.referrer);
  }, []);
  return (
    <Login
      navigation={navigation}
      onClick={onClick}
      onChange={onChange}
      setShowPassword={setShowPassword}
      showPassword={showPassword}
      form={form}
      setForm={form}
      validation={validation}
      loading={loading}
      setRecaptcha={setRecaptcha}
      loginError={loginError}
    ></Login>
  );
};

export default LoginController;
